<div class="loginDialog position-relative">
    <h2 class="mb-1" mat-dialog-title>Login</h2>
    <button class="no-hover-effect close-btn" mat-button mat-dialog-close>
    <i class="icons-times"></i>
  </button>
    <mat-dialog-content>
        <form [formGroup]="loginForm" novalidate [ngClass.xs]="'w-mobile'" >
            <div class="row" *ngIf="this.additionalLoginTitle">
              <div class="col-sm-12">
                  <label class="additional-login-dialog-title">{{this.additionalLoginTitle}}</label>
              </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <mat-form-field class="full-width">
                        <input type="email" matInput placeholder="Email" formControlName="email" />
                        <mat-error *ngIf="loginForm.controls['email'].hasError('required')"> Email is <strong>required</strong> </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12">
                  <mat-form-field class="full-width">
                    <input matInput [type]="showPassword ? 'text' : 'password'" placeholder="Password" formControlName="password" />
                    <mat-icon style="cursor: pointer" matSuffix (click)="showPassword = !showPassword">{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error *ngIf="loginForm.controls['password'].hasError('required')"> Password is <strong>required</strong> </mat-error>
                  </mat-form-field>
                </div>
            </div>

            <div class="row" *ngIf="false">
                <div class="col">
                    <mat-checkbox formControlName="rememberme" color="primary">Remember me</mat-checkbox>
                </div>
            </div>

            <div class="loginDialog__captcha d-flex justify-content-lg-center mt-2">
                <re-captcha (resolved)="captchaResolved($event)" *ngIf="this.captchaAvailable()"
                            [siteKey]="this.service.captchaService.getCurrentCaptchaKey()"> </re-captcha>
            </div> 
        </form>
    </mat-dialog-content>
    <mat-dialog-actions>
        <!-- <button mat-raised-button mat-dialog-close>Cancel</button> -->
        <button mat-raised-button class="full-width" color="primary" (click)="onSubmit()">Login</button>
        <div class="w-100 text-center pt-2 pb-2">
            <a class="standard-link" (click)="closeAction()" routerLink="/reset-password">
        Forgot your password ?
      </a>
        </div>

        <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <mat-divider fxFlex="1 0"></mat-divider>
            <div class="divider-caption">OR</div>
            <mat-divider fxFlex="1 0"></mat-divider>
        </div>

        <div class="w-100 text-center pt-2 pb-2">
            <a class="standard-link create-button" (click)="closeAction()" routerLink="/register" >
        Don't have an account? Create one here
      </a>
        </div>
    </mat-dialog-actions>
</div>
